import { Box, styled } from '@mui/material';

export const ToolbarSection = styled(Box)({
  padding: '16px 0',
  width: '100%',
  display: 'flex',
  button: {
    marginLeft: '16px'
  }
});

export const Hr = styled('hr')({
  width: 'calc(100% + 32px)',
  margin: '0 -16px',
  border: 'none',
  borderBottom: '1px solid #EDEFF2'
});

export const ImagesContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  padding: '0 11px 50px 11px',
  minHeight: '332px'
});

export const ImageWrapper = styled(Box)({
  padding: '10px',
  margin: '8px',
  border: '1px solid #d1d1d1',
  borderRadius: '10px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  cursor: 'pointer',
  maxHeight: '128px',
  '&:hover': { backgroundColor: '#EDEFF2' }
});

export const Image = styled('img')({
  maxWidth: '110px',
  maxHeight: '110px',
  borderRadius: '4px'
});

export const ImageName = styled(Box)({
  marginTop: 'auto',
  width: '110px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  paddingTop: '4px',
  textAlign: 'center',
  fontSize: '12px'
});
